import { get, filter, isUndefined } from "lodash"
import { createSelector } from "reselect"

export const getIsSuperuser = state => get(state, "user.isSuperuser", false)
export const getNeedSignTerms = (state) => get(state, "global.selected.accountMeta.needSignTerms", false)
export const getIsOpPro = (state) => {
  const plan = get(state, "global.selected.accountMeta.plan")
  // Need to returned undefined to signify that the resource is not loaded yet
  // otherwise the selector will return false until its loaded and cause
  // enterprise schema only queries to break
  if (isUndefined(plan)) { return undefined }
  return plan === "pro"
}
export const getSelectedAccount = (state) => get(state, "global.selected.account")
export const getUserDatasets = (state) => get(state, "global.data.userDatasets.data.datasets")
export const getDatasetEntitlementsEnabled = (state) => get(state, "global.selected.accountMeta.datasetEntitlements", false)
export const getIsIntradayAccountEnabled = state => get(state, "global.selected.accountMeta.intradayEnabled", false)
export const getDefaultCurrencyId = state => get(state, "global.selected.accountMeta.defaultCurrency")
const getAiTermsAndConditions = state => get(state, "global.data.aiTermsAndConditions.data", false)

export const getModels = createSelector(
  [getUserDatasets],
  (datasets) => filter(datasets, ({ type }) => type === "MODEL"),
)

export const getAiTermsAccepted = createSelector(
  [getAiTermsAndConditions],
  (aiTerms) => get(aiTerms, "enabled"),
)
